<div
  class="drop-container"
  [ngClass]="{ required: isRequired }"
  ngFileDrop
  [options]="uploadOptions"
  (uploadOutput)="onUploadOutput($event)"
  [uploadInput]="uploadInput"
  (click)="fileSelector.click()"
>
  <div class="drop-container-content">
    <span class="oi oi-data-transfer-download"></span>
    <br />
    <span>Drop or</span>
    <br />
    <span>{{ fileUploadTextSecondLine }}</span>
  </div>
</div>
<input
  type="file"
  ngFileSelect
  [options]="uploadOptions"
  (uploadOutput)="onUploadOutput($event)"
  [uploadInput]="uploadInput"
  [multiple]="maxUploads !== 1"
  [disabled]="disabled"
  hidden
  #fileSelector
/>
<div class="file-container my-3">
  <div
    *ngIf="files.length && fileTypes && uploadType === 'input' && fileTypeModel"
    class="set-types-container d-flex align-items-center"
  >
    <label for="setallfiletypes">Set all image types: </label>
    <select
      class="form-control w-100 col"
      [ngModel]="fileTypeModel.id"
      (ngModelChange)="changeInputTypeModel($event)"
      name="setallfiletypes"
    >
      <option *ngFor="let item of fileTypes" [value]="item.id">
        {{ item.name }}
      </option>
    </select>
  </div>

  <ul class="list-group">
    <li
      class="list-group-item d-flex flex-row align-items-center top-element"
      *ngFor="let container of files; index as i"
    >
      <div class="preview-container">
        <img
          class="image-preview"
          [src]="container.file.imagePreview || RR_THUMBNAIL"
        />
      </div>
      <div class="text-container w-100 d-flex flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <span>{{ container.file.name }}</span>
          <span
            class="oi oi-trash clickable"
            (click)="removeFile(container)"
            *ngIf="container.file.progress.status === UploadStatus.Queue"
          ></span>
          <span
            class="oi oi-circle-check text-success"
            *ngIf="
              container.file.progress.status === UploadStatus.Done &&
              (container.file.responseStatus === 200 ||
                container.file.responseStatus === 201)
            "
          ></span>
          <div
            *ngIf="container.file.progress.status === UploadStatus.Uploading"
            class="spinner-border"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
          <span
            class="oi oi-circle-x text-danger"
            *ngIf="container.file.responseStatus === 400"
          ></span>
        </div>
        <div class="mt-3 w-100">
          <input
            class="form-control"
            id="name-{{ i }}"
            name="name-{{ i }}"
            [(ngModel)]="container.containerModel.name"
            required
          />
        </div>

        <div
          class="mt-3 w-100"
          *ngIf="
            !(
              (container.file.progress.status === UploadStatus.Done &&
                container.file.responseStatus === 200) ||
              container.file.responseStatus === 201
            ) &&
            fileTypes &&
            uploadType === 'input'
          "
        >
          <select
            class="form-control w-100"
            [(ngModel)]="container.containerModel.typeId"
            (ngModelChange)="
              changeInputTypeModel($event, container.containerModel)
            "
            [name]="'select-fileType-' + i"
          >
            <option
              *ngFor="let item of fileTypes"
              [value]="item.id"
              [disabled]="container.file.progress.status !== UploadStatus.Queue"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>
    </li>
  </ul>
</div>
<button
  *ngIf="!hideUploadButton"
  class="btn btn-outline-primary btn-block"
  [disabled]="files.length === 0"
  [hidden]="isUploading"
  (click)="startUpload()"
>
  Upload
</button>
<h4 [hidden]="!isUploading">
  Uploading ... File {{ uploadedFiles.length }} of
  {{ files.length }}
</h4>
